// src/pages/Supervisor/SupervisorPage.jsx
import React from 'react';
import SupervisorList from '../../components/Supervisor/SupervisorList';
import { Link } from 'react-router-dom';

const SupervisorPage = () => {
    return (
        <div>
            <h1>Gestão de Supervisores</h1>
            <Link to="/supervisores/registrar">Registrar Novo Supervisor</Link>
            <SupervisorList />
        </div>
    );
};

export default SupervisorPage;